/**
 * /src/app.js
 */
import "../css/style.scss";

// ==============================
// details/summaryの開閉アニメーション
// ==============================
const initDetailsAnimation = () => {
  // アニメーションの時間とイージング
  const animTiming = {
    duration: 300,
    easing: "ease-in-out",
  };

  // アコーディオンを閉じるときのキーフレーム
  const closingAnimation = content => [
    {
      height: content.offsetHeight + "px",
      opacity: 1,
    },
    {
      height: 0,
      opacity: 0,
    },
  ];

  // アコーディオンを開くときのキーフレーム
  const openingAnimation = content => [
    {
      height: 0,
      opacity: 0,
    },
    {
      height: content.offsetHeight + "px",
      opacity: 1,
    },
  ];

  for (const el of document.querySelectorAll("details.js-accordion")) {
    const summary = el.querySelector("summary");

    if (!summary) {
      continue;
    }

    // summary以降の要素を.js-accordion__contentで囲む
    let content = el.querySelector(".js-accordion__content");
    if (!content) {
      // まだラップされていない場合、ラップ用のdivを作成
      content = document.createElement("div");
      content.className = "js-accordion__content";

      // summaryの次の兄弟要素から全てを取得してcontentに移動
      const siblings = [];
      let nextElement = summary.nextElementSibling;
      while (nextElement) {
        siblings.push(nextElement);
        nextElement = nextElement.nextElementSibling;
      }

      // 取得した要素をcontentに追加
      siblings.forEach(sibling => {
        content.appendChild(sibling);
      });

      // contentをdetailsに追加
      el.appendChild(content);
    }

    summary.addEventListener("click", event => {
      // デフォルトの挙動を無効化
      event.preventDefault();

      // detailsのopen属性を判定
      if (el.getAttribute("open") === null) {
        // open属性を付与
        el.setAttribute("open", "true");
        // アコーディオンを開くときの処理
        content.animate(openingAnimation(content), animTiming);
      } else {
        // アコーディオンを閉じるときの処理
        const closingAnim = content.animate(closingAnimation(content), animTiming);

        closingAnim.onfinish = () => {
          // アニメーションの完了後にopen属性を取り除く
          el.removeAttribute("open");
        };
      }
    });
  }
};

const fixHeader = () => {
  const fixedHeader = document.querySelector(".l-header--fix");

  if (!fixedHeader) {
    return;
  }

  const handleScroll = () => {
    const scrollY = window.scrollY || window.pageYOffset;

    if (scrollY >= 300) {
      fixedHeader.classList.add("is-active");
    } else {
      fixedHeader.classList.remove("is-active");
    }
  };

  // スクロールイベントをリスニング
  window.addEventListener("scroll", handleScroll);

  // 初期状態をチェック
  handleScroll();
};

const toggleMenu = () => {
  const menuButtons = document.querySelectorAll(".l-header__menu");
  const hamburger = document.querySelector(".c-hamberger");

  if (!hamburger || menuButtons.length === 0) {
    return;
  }

  menuButtons.forEach(button => {
    button.addEventListener("click", () => {
      // 全てのメニューボタンのis-activeをトグル
      menuButtons.forEach(btn => btn.classList.toggle("is-active"));

      // ハンバーガーメニューのis-activeをトグル
      hamburger.classList.toggle("is-active");
    });
  });
};

// ==============================
// フッター表示時のフローティング要素フェード
// ==============================
const fadeFloatOnFooter = () => {
  const footer = document.querySelector(".l-footer");
  const floatElement = document.querySelector(".p-tokusanhin__float");

  if (!footer || !floatElement) {
    return;
  }

  // Intersection Observerのオプション
  const options = {
    root: null, // ビューポートを基準にする
    rootMargin: "0px",
    threshold: 0, // 要素が少しでも見えたら発火
  };

  // コールバック関数
  const callback = entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // フッターが画面内に入ったらis-fadeクラスを追加
        floatElement.classList.add("is-fade");
      } else {
        // フッターが画面外に出たらis-fadeクラスを削除
        floatElement.classList.remove("is-fade");
      }
    });
  };

  // Observerを作成して監視開始
  const observer = new IntersectionObserver(callback, options);
  observer.observe(footer);
};

// ==============================
// 初期化処理
// ==============================
const initialize = () => {
  initDetailsAnimation();
  fixHeader();
  toggleMenu();
  fadeFloatOnFooter();
};

document.addEventListener("DOMContentLoaded", event => {
  initialize();
});
